export default {
  translation: {
    'form.validation.required': '{{field_name}} là bắt buộc',
    'form.validation.maxlength': '{{field_name}} quá dài',
    'form.validation.minlength': '{{field_name}} quá ngắn',
    'form.validation.invalid': '{{field_name}} không hợp lệ',
    'form.validation.unique':
      '{{field_name}} đã có người dùng. Xin hãy chọn lại.',
    'membership.profile.optional_field': '(Không bắt buộc)',
    'dropdown.hint': 'Xin hãy lựa chọn',

    'member_points.unit': 'Điểm',
    'member_points.point_balance': 'Số dư điểm',
    'member_points.point_history': 'Lịch sử điểm',
    'member_points.fields.date': 'Ngày',
    'member_points.rule': 'Quy định điểm thành viên',
    'member_points.display.expire_point': 'Điểm sẽ hết hạn vào ngày',
    'member_points.display.successive_expire_point':
      'Điểm sẽ hết hạn liên tiếp sau',
    'member_points.fields.expire': '\bHết hạn',
    'member_points.fields.successive_expire': 'Hết hạn liên tiếp sau đó',
    'member_points.fields.remarks': 'Lý do thay đổi điểm',
    'member_points.fields.value': 'Điểm phát sinh',
    'member_points.fields.expiry_date': 'Ngày hết hạn',
    'member_points.fields.member_point_expired': 'Số điểm hết hạn',
    'member_points.fields.auto_reward': 'Điểm thưởng từ đơn hàng',
    'member_points.fields.auto_reward_seconds': 'Kiếm điểm',
    'member_points.no_data': 'Không có thông tin điểm',
    'member_points.fields.product_review_reward':
      'Đã hoàn tất đánh giá cho đơn hàng <a></a>',
    'member_points.fields.revert_member_point.order_edit':
      'Điểm thưởng được hoàn trả từ đơn hàng đã chỉnh sửa',
    'member_points.fields.revert_member_point.return_order_revert':
      'Reverted points; from return',
    'member_points.fields.revert_member_point.order':
      'Reverted points; from order',
    'member_points.fields.member_info_reward':
      'Phần thưởng điểm thành viên hoàn thành hồ sơ thành viên',
    'member_points.redeem_cash_description':
      'Mỗi {{costPoint}} điểm Giảm giá {{discountMoney}}',
    'member_points.fields.revert_member_point':
      'Điểm được hoàn lại từ đơn hàng đã hủy',
    'member_points.equal_cash': 'Tương đương với {{money}}',
    'member_points.title': 'Điểm thành viên',
    'member_points.fields.expired': 'Điểm đã hết hạn',
    'store_credits.fields.display.never_expired': 'Vô thời hạn',
    'member_points.fields.order_redeemed':
      'Điểm đổi thành quà tặng cho đơn hàng',
    'member_points.fields.redeemed_to_cash':
      'Điểm đổi thành tiền mặt cho đơn hàng',
    'member.center.load.more': 'Nhiều hơn',
    'store_credits.fields.never_expires_point': 'Điểm không có thời hạn',
    'member_points.display.redeem_btn': 'Đổi quà',
    'promotions.page.term.confirm': 'Xác nhận',

    'store_credits.title': 'Điểm tại cửa hàng',
    'store_credits.credit_balance': 'Số dư điểm thưởng',
    'store_credits.credit_history': 'Lịch sử sử dụng điểm',
    'store_credits.fields.date': 'Ngày',
    'store_credits.fields.remarks': 'Lý do thay đổi điểm thưởng',
    'store_credits.fields.value': 'Điểm thưởng phát sinh',
    'store_credits.fields.expiry_date': 'Ngày hết hạn',
    'store_credits.fields.balance': 'Số dư điểm thưởng',
    'store_credits.fields.order_prefix': 'Sử dụng điểm cho đơn hàng',
    'store_credits.fields.welcome_credit': 'Điểm Chào mừng',
    'store_credits.fields.member_info_quick_completion_credit':
      'Phần thưởng điểm tín dụng hoàn thành hồ sơ thành viên',
    'store_credits.fields.birthday_credit': 'Điểm Sinh nhật',
    'store_credits.fields.user_credit_expired': 'Điểm đã hết hạn',
    'store_credits.fields.never_expires': 'Không bao giờ hết hạn',
    'store_credits.fields.auto_reward_prefix': 'Order ',
    'store_credits.fields.auto_reward': '  gets reward credits',
    'store_credits.fields.revert_credit':
      'Điểm được trả lại từ đơn hàng bị hủy',
    'store_credits.fields.revert_credit.return':
      'Điểm tín dụng được hoàn lại từ đơn hàng hoàn lại',
    'store_credits.fields.revert_credit.order_split':
      'Credits reverted from split order',
    'store_credits.fields.revert_credit.order_edit':
      'Điểm tín dụng được hoàn trả từ đơn hàng đã chỉnh sửa',
    'store_credits.fields.revert_credit.order': 'Reverted credits; from order',
    'store_credits.fields.revert_credit.return_order_revert':
      'Reverted credits; from return',
    'store_credits.fields.product_review_reward':
      'Đã hoàn tất đánh giá cho đơn hàng <a></a>',
    'store_credits.no_data': 'Không có hồ sơ điểm',

    'member_point.list.empty.description':
      'Hoàn tất đặt hàng để nhận thêm điểm cửa hàng!',
    'store_credits.list.empty.description':
      'Hoàn tất đặt hàng để nhận thêm điểm tín dụng!',
    'member_center.list.empty.buttonText': 'Tiếp tục mua sắm!',
    // Member Profile
    'member_profile.member_info.title':
      'Phần thưởng hoàn thành hồ sơ thành viên',
    'member_profile.member_info.hint':
      'Điền thông tin thành viên sau: {{fields}}, bạn có thể nhận được {{rewards}} sau khi điền thông tin hồ sơ',
    'member_profile.member_info.sent':
      'Sau khi kiểm tra thông tin hoàn tất, phần thưởng Hoàn thành Hồ sơ Thành viên sẽ được phát hành!',
    'member_profile.member_referral.discount':
      'Chiến dịch giới thiệu thành viên',
    'member_profile.member_referral.rules': 'Quy tắc chiến dịch',
    'member_profile.member_referral.code.copy_and_share':
      'Chia sẻ liên kết với bạn bè của bạn, cả hai bạn đều sẽ nhận được điểm tín dụng của cửa hàng.',
    'member_profile.member_referral.code.remarks': 'Quy tắc chiến dịch',
    'member_profile.member_referral.generate.success':
      'Liên kết giới thiệu được tạo',
    'member_profile.member_referral.copy': 'Sao chép liên kết',
    'member_profile.member_referral.copy.success': 'Liên kết được sao chép',
    'membership.profile.email': 'Địa chỉ email',
    'membership.profile.verification_hint':
      'Nếu bạn thay đổi địa chỉ email thì cần phải xác minh sau khi lưu. Email sẽ được cập nhật thành {{unconfirmedEmail}} sau khi xác minh xong.',
    'membership.profile.verified_success': 'Đã xác minh',
    'membership.profile.not_verified_yet': 'Chưa được xác minh',
    'membership.profile.send_verification_email': 'Gửi email xác minh',
    'users.save.email_verification.success':
      'Các thay đổi của bạn đã được lưu. Địa chỉ email sẽ được cập nhật sau khi hoàn tất xác thực.',
    'users.save.email_verification.send': 'Email xác minh đã được gửi',
    'user.sign_up.email_verification.dialog.title':
      'Email Xác thực đã được gửi tới {{email}}',
    'user.sign_up.email_verification.dialog.description':
      'Xin hãy xác thực email ngay và địa chỉ email mới sẽ được cập nhật. Nếu bạn chưa nhận được thư, xin hãy nhập lại email và lưu lại.',
    'user.sign_up.email_verification.dialog.confirm': 'Xác nhận',

    'users.membership.member_info.title':
      'Phần thưởng hoàn thành hồ sơ thành viên',
    'users.membership.member_info.hint':
      'Điền thông tin thành viên sau: {{fields}}, bạn có thể nhận được {{rewards}} sau khi điền thông tin hồ sơ',
    'users.membership.member_info.sent':
      'Sau khi kiểm tra thông tin hoàn tất, phần thưởng Hoàn thành Hồ sơ Thành viên sẽ được phát hành!',
    'users.membership.member_info.symbol': ', ',
    'users.membership.member_info.name': 'Tên',
    'users.membership.member_info.email': 'Email',
    'users.membership.member_info.mobile': 'Số điện thoại',
    'users.membership.member_info.gender': 'Giới tính',
    'users.membership.member_info.gender.male': 'Nam',
    'users.membership.member_info.gender.female': 'Nữ',
    'users.membership.member_info.gender.other': 'Không khai báo',
    'users.membership.member_info.birthday': 'Sinh nhật',
    'users.membership.member_info.password': 'Mật khẩu',
    'users.membership.member_info.password.change': 'Đặt mật khẩu mới',
    'users.membership.member_info.account_binding': 'Third-Party Account',
    'users.membership.member_info.user_credits': '${{count}} tín dụng cửa hàng',
    'users.membership.member_info.member_points': '{{count}} điểm thành viên',
    'users.membership.member_info.coupons': '{{count}} phiếu giảm giá',
    'users.membership.tier.extend.single_purchase':
      'No single purchase over {{dollar}} within {{month}}-month membership valid period.',
    'users.membership.tier.extend.single_purchase.can_extend':
      'You have a single purchase over {{dollar}} within {{month}}-month membership valid period. Membership extension will be effective on expiry date.',
    'users.membership.tier.extend.top_level.single_purchase':
      'No single purchase over {{dollar}} within {{month}}-month membership valid period.',
    'users.membership.tier.extend.top_level.single_purchase.can_extend':
      'You have a single purchase over {{dollar}} within membership valid period. Congrats! Membership extension will be effective on expiry date.',
    'users.membership.tier.extend.within_interval':
      'Your total purchase within {{month}}-month membership valid period is {{spending}}. {{dollar}} more to extend.',
    'users.membership.tier.extend.within_interval.can_extend':
      'Your total purchase within {{month}}-month membership valid period is over {{dollar}}. Extension will be effective on expiry date.',
    'users.membership.tier.extend.top_level.within_interval':
      '{{dollar}} more to extend',
    'users.membership.tier.extend.top_level.within_interval.can_extend':
      'Congrats! Extension will be effective on expiry date.',
    'users.member.normal-level': 'Basic',
    'users.membership.expiry_date': 'Ngày hết hạn thành viên',
    'users.membership.expire.unlimited': 'Never Expire',
    'users.membership.tier.expire.date.description':
      'Điều kiện nâng cấp sẽ được kiểm tra vào lúc nửa đêm. Việc nâng cấp thành viên sẽ không có hiệu lực nếu đơn hàng bị hủy/ hoàn tiền.',
    'users.membership.tier.expire.date.auto_downgrade.description':
      'Điều kiện nâng cấp sẽ được kiểm tra vào lúc nửa đêm. Việc nâng cấp thành viên sẽ không có hiệu lực nếu đơn hàng bị hủy/ hoàn tiền.',
    'users.membership.tier.extension.date.description':
      'Membership extension will not be effective if order has been cancelled/refunded.',
    'users.membership.offer.discount': 'Ưu đãi dành cho thành viên',
    'users.membership.upgrade.next_tier': 'Nâng cấp thành {{tier_name}}',
    'users.membership.upgrade.next_tier.discount':
      ' để nhận {{discount}}% ưu đãi.',
    'users.membership.extension.condition': 'Điều kiện mở rộng',
    'users.membership.extension.status': 'Membership Extend Status',
    'users.membership.spending_single_purchase':
      'Nâng cấp bằng cách mua hàng đơn lẻ trên {{spending}} đồng',
    'users.membership.all.spending_within_months':
      'Tổng giá trị mua hàng trên {{spending}} đồng trong thời hạn {{months}} tháng là thành viên.',
    'users.membership.all_tiers': 'Xem tất cả các cấp độ thành viên',
    'users.membership.tier.upgrade.condition.dollar':
      'Hiện tại mua đơn lẻ vẫn chưa đạt trên {{dollar}}.',
    'users.membership.tier.upgrade.condition.continue': 'Tiếp tục mua hàng?',
    'users.membership.tier.extend': 'Eligible to extend {{tier}}?',
    'users.membership.tier.upgrade.to_next_level.single': 'Nâng cấp lên?',
    'users.membership.tier.upgrade.completed': 'Đủ điều kiện để nâng cấp',
    'users.membership.tier.discount_percentage.caption':
      'giảm giá {{ value }}%',

    'membership.profile.birthday': 'Ngày sinh',
    'birthday_picker.year.placeholder': 'Year',
    'birthday_picker.month.placeholder': 'Month',
    'birthday_picker.date.placeholder': 'Date',
    'form.validation.birthday.required': 'Birthday is required',
    'form.validation.birthday.invalid': 'Birthday is invalid',
    'form.validation.birthday.invalid.minimum_age_limit':
      'Birthday is invalid, should over {{minimumAgeLimit}} years old.',
    'users.birthday.faq':
      'You should over certain age to register and shop at the online store.',
    'membership.edit.send_me_check_mode': 'Gửi cho tôi mã kiểm tra',
    'membership.edit.select_saved_mobile_number': 'Chọn số liên lạc đã lưu',
    'session.mobile_signup.check_mobile.title':
      'Xin hãy kiểm tra xem số điện thoại di động của bạn có đúng không bên dưới, tin nhắn sms sẽ được gửi tới số di động này',
    'session.mobile_signup.check_mobile.your_number':
      'Số điện thoại di động của bạn',
    'session.mobile_signup.check_mobile.send_code': 'Gửi mã kiểm tra cho tôi',
    'session.mobile_signup.check_mobile.go_back.1': 'bạn có thể',
    'session.mobile_signup.check_mobile.go_back.2': 'quay lại',
    'session.mobile_signup.check_mobile.go_back.3':
      'để sửa lại số di động nếu bị sai',
    'session.mobile_signup.input_code.hint':
      'Xin hãy nhập mã kiểm tra bạn đã nhận',
    'session.mobile_signup.input_code.submit': 'Đi',
    'session.mobile_signup.input_code.resend.countdown':
      'Gửi lại sms mã kiểm tra tới số di động của tôi ({{resendCountdown}} giây)',
    'session.mobile_signup.input_code.resend':
      'Gửi lại sms mã kiểm tra tới số di động của tôi',
    'session.forget_passowrd.check_phone.error':
      'Số di động không chính xác, vui lòng kiểm tra lại',
    'session.mobile_center.check_phone.error': 'Số di động này đã được dùng',
    'user.sign_up.check_phone.error':
      'This is same as current mobile phone.<br>Please change another phone if you want to update it.',
    'membership.profile.mobile.number.verified':
      'Số điện thoại di động đã được xác thực và sẽ thay thế số điện thoại bạn đã lưu trước đó.',
    'membership.profile.delivery_addresses': 'Địa chỉ giao hàng đã lưu',
    'users.add.delivery_address.maximum':
      'Bạn chỉ có thể thêm tối đa 5 địa chỉ.',
    'users.add.delivery_address': 'Thêm địa chỉ mới',
    'checkout.address.recipient': 'Tên người nhận',
    'checkout.address.recipient_phone': 'Số điện thoại của người nhận',
    'member_profile.line.subscribe.error.already_in_used':
      'This LINE account is already in use by another member. Please contact the store for assistance.',
    'member_profile.subscribed': 'Subscribed',
    'member_profile.notification.promotion': 'Promotion Notification',
    'member_profile.notification.order': 'Order Notification',
    'member_profile.subscribe.successfully': 'Subscribed successfully.',
    'member_profile.subscribe.error':
      'Failed to subscribe. Please contact the store.',
    'member_profile.line.subscribe.error.already_for_registration':
      'Failed to subscribe. This LINE account is already used for registration by another member. Please log in with the LINE account and try again.',
    'member_profile.line.subscribe.error.different_id':
      'Failed to subscribe. Please log in with the LINE account of the member account.',
    'member_profile.line.subscribe.error':
      'Failed to subscribe. Please log in to LINE again.',
    'member_profile.facebook.subscribe.error':
      'Failed to subscribe. Please log in to Facebook again.',
    'member_profile.social.subscribe.error.already_bound_to':
      'Failed to subscribe. This social account is already bound to another member. Please contact the store to unbind.',
    'member_profile.email.subscribe.error':
      'Failed to subscribe. Please enter an email address and try again.',
    'member_profile.sms.subscribe.error':
      'Failed to subscribe. Please enter a mobile number and try again.',
    'member_profile.unsubscribe.successfully': 'Unsubscribed successfully.',
    'member_profile.unsubscribe.error':
      'Failed to unsubscribed, please try again later.',
    'member_profile.error.unknown': 'Oops! An unexpected error has occurred.',
    'member_profile.error.refresh':
      'Please refresh the page or try again later.',
    'member_profile.retry': 'Try again',
    'member_profile.profile': 'Member profile',
    'member_profile.subscription': 'Subscription',
    'member_profile.delivery_payment': 'Delivery and payment info',
    'member_profile.phone': 'Contact Phone',
    'users.invoice_carrier': '發票載具',
    'users.electronic_invoice_carrier':
      'Hóa đơn điện tử tổng hợp vào tài khoản của bạn',
    'member_profile.confirm': 'Lưu thay đổi',
    'member_profile.cancel': 'Hủy bỏ',
    'users.save.success': 'Các thay đổi của bạn đã được lưu.',
    'users.error.not_save_mobile_phone':
      'Vui lòng xác minh số điện thoại trước khi lưu thay đổi.',
    'verification.email.trial_merchant.reach_limit.failure':
      'Cửa hàng đang trong giai đoạn dùng thử nên không gửi được email xác minh. Nếu có nhu cầu vui lòng liên hệ với cửa hàng.',
  },
};
